import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default abstract class SelectTagsController extends Controller<HTMLSelectElement> {
    /**
     * Optionally override this method to provide a custom templateResult
     * for formatting Select2 results.
     */
    templateResult?(state: any): any;

    /**
     * Determines if the select should allow multiple selections.
     * Override in the derived controller to enable multiselect.
     */
    get multiple(): boolean {
        return true;
    }

    connect(): void {
        const config: any = {
            language: 'ru',
            placeholder: "Введите станции метро",
            theme: "bootstrap-5",
            containerCssClass: "select2--small",
            selectionCssClass: "select2--small",
            dropdownCssClass: 'select2-hidden',
            multiple: true,
            width: '100%',
            tags: true,
            tokenSeparators: [','],
            allowClear: true
        }

        // If the derived controller provides a templateResult function, merge it in.
        if (this.templateResult) {
            config.templateResult = this.templateResult;
        }

        $(this.element).select2(config);

        $(this.element).on("select2:select", (e) => {
            this.element.classList.remove("is-invalid");
        });
    }

    disconnect(): void {
        $(this.element).select2("destroy");
    }
}
